import { STENCIL_ROUTE_BUSY_CONTENT_SELECTOR } from './stencil-route-content.constants';
import type { StencilRouteContentSnapshot, StencilRouteContentStatus } from './stencil-route-content.model';

interface StencilElementConstructor extends CustomElementConstructor {
    is?: string;
}

const isVisible = (element: Element) => {
    const styles = globalThis.getComputedStyle(element);
    return styles.display !== 'none' && styles.visibility !== 'hidden' && element.getClientRects().length > 0;
};

const isStencilElement = (element: Element) => {
    const constructor = globalThis.customElements.get(element.localName) as StencilElementConstructor | undefined;
    return constructor?.is === element.localName;
};

export const resolveStencilRouteContentRoot = (contentSelector: string): Element =>
    document.querySelector(contentSelector) ?? document.body;

export const captureStencilRouteContent = (root: Element): StencilRouteContentSnapshot => ({
    elements: new Set(root.querySelectorAll('*')),
    text: root.textContent ?? '',
});

export const readStencilRouteContentStatus = (root: Element): StencilRouteContentStatus => {
    const hasVisibleBusyContent = [...root.querySelectorAll(STENCIL_ROUTE_BUSY_CONTENT_SELECTOR)].some(isVisible);
    const hasUnhydratedStencilContent = [...root.querySelectorAll('*')].some(
        (element) =>
            isStencilElement(element) && !element.hasAttribute('hydrated') && !element.classList.contains('hydrated')
    );

    return { hasUnhydratedStencilContent, hasVisibleBusyContent };
};
